var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TPage',{staticClass:"container-md mx-auto w-100",attrs:{"slug":_vm.$route.params.slug}})}
var staticRenderFns = []

export { render, staticRenderFns }